import { defineMessages } from "react-intl";

const messages = defineMessages({
  cardTitle: {
    id: "dashboard.editModal.upcomingActivities.cardTitle",
    defaultMessage:
      "Upcoming Activities <date>{dateRange, select, day {{dateSubRange, select, this {today} next {tomorrow} other {}}} week {{dateSubRange, select, this {this week} next {next week} other {}}} month {{dateSubRange, select, this {this month} next {next month} other {}}} quarter {{dateSubRange, select, this {this quarter} next {next quarter} other {}}} year {{dateSubRange, select, this {this year} next {next year} other {}}} other{}}</date>",
    description: "Title of the Upcoming activities card",
  },
  modalTitle: {
    id: "dashboard.editModal.upcomingActivities.modalTitle",
    defaultMessage: "Edit “Upcoming Activities”",
    description: "Title of the Edit Upcoming Activities modal",
  },
});

export default messages;
